export default "__VITE_ASSET__DJyRuqEr__"